import { render, staticRenderFns } from "./DocumentationBlockView.vue?vue&type=template&id=5519f131"
import script from "./DocumentationBlockView.vue?vue&type=script&lang=js"
export * from "./DocumentationBlockView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports